import { useGetUserCredentialsQuery } from 'gqlTypes'

const useUserSignedIn = () => {
  const { data } = useGetUserCredentialsQuery({
    fetchPolicy: 'cache-only',
  })
  return !!data?.userCredentials?.authToken
}
export default useUserSignedIn
